import React from 'react';
import PropTypes from 'prop-types';

// Components
import { FilterDate, FilterGroups, DownloadButton } from '@components';

import { FiltersContainer } from './../Styled';

const ChartHeader = ({ getFilterDate, getFilterGroups, onDownload }) => (
  <FiltersContainer>
    <div>
      <FilterDate filter="graphicStudyHours" getFilterDate={getFilterDate} />
      <FilterGroups
        filter="graphicStudyHours"
        getFilterGroups={getFilterGroups}
      />
    </div>
    {onDownload ? <DownloadButton onDownload={onDownload} variant="text" /> : null}
  </FiltersContainer>
);

ChartHeader.propTypes = {
  getFilterDate: PropTypes.func.isRequired,
  getFilterGroups: PropTypes.func.isRequired,
  onDownload: PropTypes.func,
};

ChartHeader.defaultProps = {
  onDownload: null,
};

export default ChartHeader;
export { ChartHeader };
